import { normalize } from 'normalizr';
import Cookies from 'universal-cookie';
import _find from 'lodash/find';
import _keys from 'lodash/keys';
import ApiService from '../../util/api';

import { createWeddingForExistingUser } from '../../actions/WeddingActions';
import { getCardByVariationUUID } from './cardCatalogActions'; // eslint-disable-line
import { getCookie } from '../../util/storage';
import { trackOptimizelyEvent } from '../../util/trackingHelper'; // eslint-disable-line
import inOptimizelyExperiment from '../../util/optimizelyHelper'; // eslint-disable-line
import { testPublishWebsiteInviteRedirectVariationA, testPublishWebsiteInviteRedirectVariationB } from '../../util/optimizelyConfigs';
import featureFlags from '../../util/featureFlags';

// Selectors
import {
  getProjectUUID,
  getCustomizationTypeUUIDs,
  getCustomizations
} from '../selectors/cardProjectSelector';

import projectSchema, { customizationObject } from '../schemas/projectSchema';
import { getSelectedGuestIds } from '../selectors/Customization';


export const ActionTypes = {
  RECEIVE_CUSTOMIZATION: 'zola/card/project/RECEIVE_CUSTOMIZATION',
  RECEIVE_ADD_TEXT_ELEMENT: 'zola/card/project/RECEIVE_ADD_TEXT_ELEMENT',
  RECEIVE_RESTORED_ELEMENT: 'zola/card/project/RECEIVE_RESTORED_ELEMENT',
  RECEIVE_DELETE_ELEMENT: 'zola/card/project/RECEIVE_DELETE_ELEMENT',
  RECEIVE_DELETE_ELEMENT_IMAGE: 'zola/card/project/RECEIVE_DELETE_ELEMENT_IMAGE',
  RECEIVE_PROJECT_AUTHENTICATION: 'zola/card/project/RECEIVE_PROJECT_AUTHENTICATION',
  RECEIVE_PROJECT_GUEST_IDS: 'zola/card/project/guests/RECEIVE_PROJECT_GUEST_IDS',
  RECEIVE_PROJECT: 'zola/cards/project/RECEIVE_PROJECT',
  REQUEST_CUSTOMIZATION: 'zola/cards/project/REQUEST_CUSTOMIZATION',
  REQUEST_UPDATE_CUSTOMIZATION: 'zola/cards/project/REQUEST_UPDATE_CUSTOMIZATION',
  REQUEST_PROJECT_AUTHENTICATION: 'zola/cards/project/REQUEST_PROJECT_AUTHENTICATION',
  REQUEST_PROJECT_GUEST_IDS: 'zola/cards/project/guests/REQUEST_PROJECT_GUEST_IDS',
  REQUEST_PROJECT: 'zola/cards/project/REQUEST_PROJECT',
  SET_ACTIVE_FIELD: 'zola/cards/project/SET_ACTIVE_FIELD',
  TOGGLE_RECIPIENT_ADDRESSING_OPTION: 'zola/cards/project/TOGGLE_RECIPIENT_ADDRESSING_OPTION',
  GET_CUSTOMIZATION_FONTS_REQUEST: 'zola/cards/project/GET_CUSTOMIZATION_FONTS_REQUEST',
  GET_CUSTOMIZATION_FONTS_SUCCESS: 'zola/cards/project/GET_CUSTOMIZATION_FONTS_SUCCESS',
  GET_CUSTOMIZATION_FONTS_FAILURE: 'zola/cards/project/GET_CUSTOMIZATION_FONTS_FAILURE',
  REQUEST_ADD_PROJECT_TO_CART: 'zola/cards/project/REQUEST_ADD_PROJECT_TO_CART',
  RECEIVE_ADD_PROJECT_TO_CART: 'zola/cards/project/RECEIVE_ADD_PROJECT_TO_CART',
};

function projectMapper(project) {
  const customizationTypeToUUID = {};
  project.customizations.forEach((customization) => {
    if (customization.type === 'ENVELOPE') {
      if (/rsvp/i.test(customization.name)) {
        customizationTypeToUUID.RSVP_ENVELOPE = customization.uuid;
      } else {
        customizationTypeToUUID.INVITATION_ENVELOPE = customization.uuid;
      }
    } else {
      customizationTypeToUUID[customization.type] = customization.uuid;
    }
  });
  return {
    ...project,
    customizationTypeToUUID
  };
}

function requestProject() {
  return {
    type: ActionTypes.REQUEST_PROJECT,
  };
}

function receiveProject(project) {
  return {
    type: ActionTypes.RECEIVE_PROJECT,
    payload: {
      project
    }
  };
}

function requestCustomization() {
  return {
    type: ActionTypes.REQUEST_CUSTOMIZATION
  };
}

function requestUpdateCustomization(customizationUUID) {
  return {
    type: ActionTypes.REQUEST_UPDATE_CUSTOMIZATION,
    payload: { customizationUUID }
  };
}

function getCustomizationFontsRequest() {
  return {
    type: ActionTypes.GET_CUSTOMIZATION_FONTS_REQUEST,
  };
}

function getCustomizationFontsSuccess(fonts) {
  return {
    type: ActionTypes.GET_CUSTOMIZATION_FONTS_SUCCESS,
    payload: {
      fonts
    }
  };
}

function getCustomizationFontsFailure(error) {
  return {
    type: ActionTypes.GET_CUSTOMIZATION_FONTS_FAILURE,
    payload: {
      error
    }
  };
}

function receiveCustomization(customization) {
  return {
    type: ActionTypes.RECEIVE_CUSTOMIZATION,
    payload: {
      customization
    }
  };
}

function receiveAddTextElement(customizationUUID, pageUUID, element) {
  return {
    type: ActionTypes.RECEIVE_ADD_TEXT_ELEMENT,
    payload: {
      customizationUUID,
      pageUUID,
      element
    }
  };
}

function receiveRestoredElement(customizationUUID, pageUUID, elements, lastChanges) {
  return {
    type: ActionTypes.RECEIVE_RESTORED_ELEMENT,
    payload: {
      customizationUUID,
      pageUUID,
      elements,
      lastChanges
    }
  };
}


function receiveDeleteElement(pageUUID, elementUUIDs) {
  return {
    type: ActionTypes.RECEIVE_DELETE_ELEMENT,
    payload: {
      pageUUID,
      elementUUIDs
    }
  };
}

function receiveDeleteElementImage(elementUUID, element) {
  return {
    type: ActionTypes.RECEIVE_DELETE_ELEMENT_IMAGE,
    payload: {
      elementUUID,
      element
    }
  };
}

export function toggleRecipientAddressingOption(status) {
  return {
    type: ActionTypes.TOGGLE_RECIPIENT_ADDRESSING_OPTION,
    payload: status,
  };
}

function requestProjectGuestIds() {
  return {
    type: ActionTypes.REQUEST_PROJECT_GUEST_IDS
  };
}

function receiveProjectGuestIds(projectGuestIds) {
  return {
    type: ActionTypes.RECEIVE_PROJECT_GUEST_IDS,
    payload: {
      projectGuestIds
    }
  };
}

function requestProjectAuthentication() {
  return {
    type: ActionTypes.REQUEST_PROJECT_AUTHENTICATION
  };
}

function requestAddProjectToCart() {
  return {
    type: ActionTypes.REQUEST_ADD_PROJECT_TO_CART
  };
}

function receiveAddProjectToCart() {
  return {
    type: ActionTypes.RECEIVE_ADD_PROJECT_TO_CART
  };
}

export function setActiveField(activeField) {
  return {
    type: ActionTypes.SET_ACTIVE_FIELD,
    payload: {
      activeField
    }
  };
}

export function createProject(suiteUUID, activeVariationUUID, quantity) {
  return (dispatch, getState) => { // eslint-disable-line
    const requestBody = {
      suite_uuid: suiteUUID,
      lead_variation_uuid: activeVariationUUID,
      quantity
    };
    return ApiService.post('/web-api/v3/card-project', requestBody)
      .then((json) => {
        json.customizations.forEach((customization) => {
          if (customization.variation && customization.variation.uuid) {
            dispatch(getCardByVariationUUID(customization.variation.uuid, customization.uuid));
          }
        });
        const project = projectMapper(json);
        const normalizedProject = normalize(project, projectSchema);
        dispatch(receiveProject(normalizedProject));
        return json;
      });
  };
}

export function fetchProject(projectUUID) {
  return (dispatch, getState) => { // eslint-disable-line
    dispatch(requestProject());
    return ApiService.get(`/web-api/v2/card-project/${projectUUID}`)
      .then((json) => {
        json.customizations.forEach((customization) => {
          if (customization.variation && customization.variation.uuid) {
            dispatch(getCardByVariationUUID(customization.variation.uuid, customization.uuid));
          }
        });
        const project = projectMapper(json);
        const normalizedProject = normalize(project, projectSchema);
        // console.log('normalizedProject: ', normalizedProject);
        dispatch(receiveProject(normalizedProject));
        return json;
      });
  };
}

// gets called for outside (bigger? outter?) updatesl ike changing the quantity of cards
export function updateProject(projectUUID, customizations) {
  return (dispatch, getState) => { // eslint-disable-line
    return ApiService.put(`/web-api/v2/card-project/${projectUUID}`, { customizations })
      .then((json) => {
        json.customizations.forEach((customization) => {
          if (customization.variation && customization.variation.uuid) {
            dispatch(getCardByVariationUUID(customization.variation.uuid, customization.uuid));
          }
        });
        const project = projectMapper(json);
        const normalizedProject = normalize(project, projectSchema);
        dispatch(receiveProject(normalizedProject));
        return json;
      });
  };
}

export function cloneProject(projectUUID) {
  return dispatch => (
    ApiService.post(`/web-api/v2/card-project/${projectUUID}/clone`)
      .then((json) => {
        const { uuid } = json;
        return dispatch(fetchProject(uuid));
      })
  );
}

export function fetchCustomization(uuid) {
  return (dispatch, getState) => { // eslint-disable-line
    dispatch(requestCustomization());
    return ApiService.get(`/web-api/v2/card-project/customization/${uuid}`)
      .then((json) => {
        if (json.variation && json.variation.uuid) {
          dispatch(getCardByVariationUUID(json.variation.uuid, json.uuid));
        }
        const normalizedCustomization = normalize(json, customizationObject);
        // console.log('normalizedCustomization: ', normalizedCustomization);
        dispatch(receiveCustomization(normalizedCustomization));
        return json;
      });
  };
}

function decodeCookie(cookie) {
  const invitesRedirectCookieValue = getCookie(cookie);
  if (invitesRedirectCookieValue) { // guard against unexpected empty cookie state
    const invitesRedirectUrlString = decodeURIComponent(invitesRedirectCookieValue);
    const invitesRedirectData = JSON.parse(invitesRedirectUrlString);
    return invitesRedirectData;
  }
  return false;
}

function updateRedirectCookie() {
  const cookies = new Cookies();

  const redirectTestData = decodeCookie('invitesRedirectTest');
  if (redirectTestData && !redirectTestData.timestamp) {
    redirectTestData.timestamp = Date.now(); // creates timestamp of now
    redirectTestData.counter += 1; // increments counter
    cookies.set('invitesRedirectTest', redirectTestData, { maxAge: 604800, path: '/' }); // updates cookie
    trackOptimizelyEvent('measure_invitation_activity_via_publish_flow'); // manually fires optimizely event
  } else {
    const currentTime = Date.now(); // set current time to now
    const updatedRedirectTestData = decodeCookie('invitesRedirectTest'); // get cookie
    const bufferPeriod = 14400000; // 4 hours in miliseconds
    // const bufferPeriod = 1500; // 15 seconds in miliseconds
    if ((currentTime - updatedRedirectTestData.timestamp >= bufferPeriod) && (updatedRedirectTestData.counter < 2)) { // mathy bits. there needs to be AT LEAST a 4 hr break from the last time we updated AND counter MUST be less than 2.
      updatedRedirectTestData.timestamp = Date.now(); // update cookie to now
      updatedRedirectTestData.counter += 1; // increment counter
      cookies.set('invitesRedirectTest', updatedRedirectTestData, { maxAge: 604800, path: '/' }); // update cookie
      trackOptimizelyEvent('measure_invitation_activity_via_publish_flow'); // fire optimizely event
    }
  }
}

// will take customizationUUID and using optimizely helper determine the following
// if a user is in either variation A or B (we're not testing for control)
// and if the customizationUUID matches the cookie's project uuid (std or envelope)
function checkOptimizelyForRedirectTestInclusion(customizationUUID) { // eslint-disable-line
  if (featureFlags.get('invitesModalRedirectTest')) {
    if (inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationB) || inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationA)) { // variation A or B must be present
      const redirectTestData = decodeCookie('invitesRedirectTest'); // decodes cookie
      // redirectTestData could return false so make sure to check for truthiness
      // of redirectTestData and redirectTestData.project before keying into redirectTestData.project
      if (redirectTestData && redirectTestData.project && (redirectTestData.project.projectCustomizationUUID === customizationUUID || redirectTestData.project.envelopeCustomizationUUID === customizationUUID)) { // check incoming UUID matches cookie projects' uuid
        updateRedirectCookie(); // calls to update the cookie above
      }
    }
  }
  return false;
}

export function updateCustomization(customizationUUID, customizationData) {
  return (dispatch) => { // eslint-disable-line
    // TODO: need to add this back in to set flag that an update request is in progress
    dispatch(requestUpdateCustomization(customizationUUID)); // - legacy, not related to cookie or test
    return ApiService.put(`/web-api/v2/card-project/customization/${customizationUUID}`, customizationData)
      .then((json) => {
        if (json.variation && json.variation.uuid) {
          dispatch(getCardByVariationUUID(json.variation.uuid, json.uuid));
        }
        const normalizedCustomization = normalize(json, customizationObject);
        // console.log('normalizedCustomization: ', normalizedCustomization);
        dispatch(receiveCustomization(normalizedCustomization));
        checkOptimizelyForRedirectTestInclusion(json.uuid);
        return json;
      });
  };
}

export function addTextElement(customizationUUID, pageUUID, customizationData) {
  return dispatch => (
    ApiService.post(`/web-api/v2/card-project/customization/page/${pageUUID}/element`, customizationData)
      .then((json) => {
        dispatch(receiveAddTextElement(customizationUUID, pageUUID, json));
        return json;
      })
  );
}

export function restoreElement(customizationUUID, pageUUID, elementUUID, lastChanges) {
  return dispatch => (
    ApiService.post(`/web-api/v2/card-project/element/${elementUUID}/restore`)
      .then((json) => {
        dispatch(receiveRestoredElement(customizationUUID, pageUUID, json, lastChanges));
        return json;
      })
  );
}

// TODO: remove customizationUUID from parameters when the signature no longer
// needs to match signature of legacy cardProjectActions.deleteElement
export function deleteElement(pageUUID, elementUUIDs) {
  return dispatch => (
    ApiService.delete(`/web-api/v2/card-project/element/${elementUUIDs[0]}`, {}, {}, {}, 'text')
      .then((json) => {
        dispatch(receiveDeleteElement(pageUUID, elementUUIDs));
        return json;
      })
  );
}

export function deleteElementImage(elementUUID) {
  return dispatch => (
    ApiService.delete(`/web-api/v2/card-project/element/${elementUUID}/image`)
      .then((json) => {
        dispatch(receiveDeleteElementImage(elementUUID, json));
        return json;
      })
  );
}

export function toggleRecipientAddressing(customizationUUID, enableRecipientAddressing) {
  return (dispatch, getState) => {
    // const { userContext } = getState().user;
    const requestBody = {
      recipient_addressing: enableRecipientAddressing
    };
    // actually just hits the same endpoint as updateCustomization, just with a request
    // body specific to recipient addressing
    return ApiService.put(`/web-api/v2/card-project/customization/${customizationUUID}`, requestBody)
      .then((json) => {
        const normalizedCustomization = normalize(json, customizationObject);
        // console.log('normalizedCustomization: ', normalizedCustomization);
        dispatch(receiveCustomization(normalizedCustomization));
        return json;
      })
      .then((json) => {
        const { userContext } = getState().user;
        // if the user does not have a wedding account we need to create one so that they can
        // add guests to guest list. This logic used to be handled in components but probably fits
        // better here because a wedding account must be created if recipient addressing is toggled on
        // for a user without a wedding account
        if (enableRecipientAddressing && !userContext.has_wedding_account) {
          dispatch(createWeddingForExistingUser());
        }
        return json;
      });
  };
}

export function getMediaFileUrl(mediaFileUUID) {
  return () => (
    ApiService.get(`/web-api/v1/card-project/media_file/${mediaFileUUID}/presigned_url`, {}, {}, 'text')
  );
}

export function getProjectGuestIds(projectUUID) {
  return (dispatch) => {
    dispatch(requestProjectGuestIds());
    return ApiService.get(`/web-api/v1/card-project/${projectUUID}/guests`)
      .then(json => dispatch(receiveProjectGuestIds(json)));
  };
}

export function updateProjectGuestIds(projectGuestIds) {
  return (dispatch, getState) => {
    const projectUUID = getProjectUUID(getState());
    const requestBody = {
      recipients: projectGuestIds
    };
    return ApiService.put(`/web-api/v1/card-project/${projectUUID}/guests`, requestBody)
      .then(json => dispatch(receiveProjectGuestIds(json)));
  };
}

export function updateProjectGuestId(guestId) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedGuestIds = getSelectedGuestIds(state);
    const projectUUID = getProjectUUID(state);
    const isCurrentlySelected = selectedGuestIds.indexOf(guestId) > -1;
    const requestBody = {
      recipients: {
        [guestId]: !isCurrentlySelected
      }
    };
    return ApiService.put(`/web-api/v1/card-project/${projectUUID}/guests`, requestBody)
      .then(json => dispatch(receiveProjectGuestIds(json)));
  };
}

export function getCustomizationFonts(customizationUUID) {
  return (dispatch) => {
    dispatch(getCustomizationFontsRequest());
    return ApiService.get(`/web-api/v2/card-project/customization/${customizationUUID}/fonts`)
      .then(data => dispatch(getCustomizationFontsSuccess(data)))
    // TODO: This can be move to handleErrors and pass as param the action to fire on failure
    // But we'll keep it specific to this method for now until we handle errors gobally
      .catch(err => dispatch(getCustomizationFontsFailure(err)));
  };
}

// NEW ACTIONS FOR SKU MIGRATION

export function getProjectAuthenticated(projectUUID) {
  return (dispatch) => {
    dispatch(requestProjectAuthentication());
    return ApiService.post(`/web-api/v3/card-project/${projectUUID}/is_authenticated`)
      .then(auth => auth);
  };
}

// generic function to update variation_uuid of a customization
export function updateCustomizationVariation(customizationUUID, nextOptionValues) {
  return (dispatch, getState) => {
    const state = getState();
    const customizations = getCustomizations(state);

    // get customization using customziationUUID argument
    const customization = customizations[customizationUUID];
    // grab variation from customization - this will only work for new sku model
    // variation.option_values needed to merge nextOptionValues with
    const { variation } = customization;
    // mergedOptionValues is what we use to find a matching variation from the associated
    // card
    const mergedOptionValues = { ...variation.option_values, ...nextOptionValues };
    // find card associated with current customization, each card has a customizationUUID for this purpose
    const customizationCard = _find(getState().cards.cardCatalog.cards, { customizationUUID });
    // grab next variation - this might need some error handling in the case that a variation is not found, however
    // that should be rare
    const nextVariation = _find(customizationCard.variations, { option_values: mergedOptionValues });
    const requestBody = {
      variation_uuid: nextVariation.uuid
    };
    return ApiService.put(`/web-api/v2/card-project/customization/${customizationUUID}`, requestBody)
      .then((json) => {
        if (json.variation && json.variation.uuid) {
          dispatch(getCardByVariationUUID(json.variation.uuid, json.uuid));
        }
        const normalizedCustomization = normalize(json, customizationObject);
        // console.log('normalizedCustomization: ', normalizedCustomization);
        dispatch(receiveCustomization(normalizedCustomization));
        // dispatch(receiveCustomization(json));
      });
  };
}

// moving away from 'soft deleting' customizations (like for RSVP), so instead we have a
// field on the customization object 'inactive' that we can use for the same purposes
export function toggleCustomizationActive(customizationUUID, bool) {
  return (dispatch, getState) => {
    const requestBody = {
      inactive: bool
    };
    // actually just hits the same endpoint as updateCustomization, just with a request
    // body specifically for updating inactive property
    return ApiService.put(`/web-api/v2/card-project/customization/${customizationUUID}`, requestBody)
      .then((json) => {
        const normalizedCustomization = normalize(json, customizationObject);
        // console.log('normalizedCustomization: ', normalizedCustomization);
        dispatch(receiveCustomization(normalizedCustomization));
        if (json.type === 'RSVP') {
          const rsvpEnvelopeUUID = getState().cards.project.customizationTypeToUUID.RSVP_ENVELOPE;
          if (rsvpEnvelopeUUID) {
            // IMPORTANT: this could be a bad idea recursively calling and update request
            dispatch(toggleCustomizationActive(rsvpEnvelopeUUID, bool));
          }
        }
      });
  };
}

// function that handles using v1 endpoint for projects with old sku model or v3 endpoint
// for projects with new sku model - with this action conditional logic doesnt have to be
// implemented in components
export function addProjectToCart() {
  return (dispatch, getState) => {
    const state = getState();
    const projectUUID = getProjectUUID(state);
    const requestBody = {
      projectUUID
    };
    dispatch(requestAddProjectToCart());
    return ApiService.post('/web-api/v3/card-project/cart', requestBody, {}, {}, 'text')
      .then(() => dispatch(receiveAddProjectToCart()))
      .then(() => {
        window.location = '/cart/checkout';
      });
  };
}

export function updateProjectQuantity(quantity) {
  return (dispatch, getState) => {
    // const { projectUUID, customizations } = getState().cards.cardProject;
    const state = getState();
    const projectUUID = getProjectUUID(state);
    const customizations = getCustomizations(state);
    const formattedCustomizations = _keys(customizations).reduce((result, uuid) => {
      // const customization = customizations[uuid];
      result[uuid] = { quantity }; // eslint-disable-line
      return result;
    }, {});
    return dispatch(updateProject(projectUUID, formattedCustomizations));
  };
}

// uses updateProject action to update inactive field of both rsvp and rsvp envelope cards
export function updateRSVPInactive(inactive) {
  return (dispatch, getState) => {
    // const { projectUUID } = getState().cards.cardProject;
    const state = getState();
    const projectUUID = getProjectUUID(state);
    const customizationTypeToUUID = getCustomizationTypeUUIDs(state);
    // const { customizationTypeToUUID } = getState().cards.cardProject;
    const rsvpUUID = customizationTypeToUUID.RSVP;
    const rsvpEnvelopeUUID = customizationTypeToUUID.RSVP_ENVELOPE;
    const customizations = {
      [rsvpUUID]: {
        inactive
      },
      [rsvpEnvelopeUUID]: {
        inactive
      }
    };
    return dispatch(updateProject(projectUUID, customizations));
  };
}

// generic function that takes bool inactive and array customizationTypes and generates
// object of customizations to use as input to updateProject actions
export function updateCustomizationsInactive(inactive, customizationTypes) {
  return (dispatch, getState) => {
    // const { projectUUID } = getState().cards.cardProject;
    // const { customizationTypeToUUID } = getState().cards.cardProject;
    const state = getState();
    const projectUUID = getProjectUUID(state);
    const customizationTypeToUUID = getCustomizationTypeUUIDs(state);
    const customizations = customizationTypes.reduce((result, type) => {
      const uuid = customizationTypeToUUID[type];
      result[uuid] = { inactive };  // eslint-disable-line
      return result;
    }, {});
    return dispatch(updateProject(projectUUID, customizations));
  };
}

export const actions = {
  setActiveField,
  toggleRecipientAddressingOption,
  createProject,
  fetchProject,
  updateProject,
  cloneProject,
  fetchCustomization,
  updateCustomization,
  addTextElement,
  restoreElement,
  deleteElement,
  deleteElementImage,
  toggleRecipientAddressing,
  getMediaFileUrl,
  getProjectGuestIds,
  updateProjectGuestIds,
  getCustomizationFonts,
  getProjectAuthenticated,
  updateCustomizationVariation,
  toggleCustomizationActive,
  addProjectToCart,
  updateProjectQuantity,
  updateRSVPInactive,
  updateCustomizationsInactive,
  updateProjectGuestId
};



// WEBPACK FOOTER //
// ./src/cards/actions/projectActions.js